<template>
  <SfModal
    v-if="modalOpen"
    :class="modalClass"
    data-walkthrough-id="restore-default-modal"
    @close="close"
  >
    <template #title>{{
      I18n.t('js.live_inputs.revert_modal.title')
    }}</template>

    <template #messages>
      <SfModalMessage variant="warning">
        {{ I18n.t('js.live_inputs.revert_modal.message') }}
      </SfModalMessage>
    </template>

    <template #body>
      <div class="sf-grid">
        <div class="sf-row">
          <div class="sf-col sf-pad-h-3">
            <div class="sf-c-text sf-pre-wrap">{{ defaultValue }}</div>
            <span class="sf-c-text-light sf-font-xs">{{
              I18n.t('js.live_inputs.revert_modal.label')
            }}</span>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="sf-btn sf-btn-warning sf-level-item" @click.prevent="save">
        {{ I18n.t('js.live_inputs.revert_modal.title') }}
      </div>
      <div class="sf-btn sf-level-item" @click.prevent="close">
        {{ I18n.t('common.form.cancel') }}
      </div>
    </template>
  </SfModal>
</template>

<script>
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'

export default {
  components: {
    SfModal,
    SfModalMessage,
  },

  data() {
    return {
      modalOpen: false,

      saveCallback: () => {},
      defaultValue: null,
      isInput: false,
    }
  },

  computed: {
    modalClass() {
      return `sf-modal-${this.isInput ? 'xs' : 'm'}`
    },
  },

  methods: {
    openModal(data) {
      this.isInput = data.isInput
      this.defaultValue = data.defaultValue
      this.saveCallback = data.saveCallback
      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    save() {
      this.saveCallback()
      this.close()
    },
  },
}
</script>
